<div id="cxAlerts"></div>
@if (alerts$ | async; as alerts) {
  @if (alerts.length) {
    <div>
      @for (alert of alerts; track alert.errorId) {
        <app-alert
          [level]="alert.level"
          [message]="alert.message"
          [dismissDelay]="7000"
        ></app-alert>
      }
    </div>
  }
}

<div class="tw-px-6 tw-pb-4">
  <form [formGroup]="cxInteractionForm" #formDirective="ngForm" 
  (ngSubmit)="onSaveCxInteraction(formDirective)">
    <div class="tw-p-2 tw-border-b tw-border-slate-300 tw-flex tw-items-center">
      <div class="tw-text-2xl tw-font-semibold">CX Interactions</div>
      <div class="tw-ml-auto tw-flex tw-items-center">
        @if (hasClearableContent()) {
          <button
            type="button"
            data-cy="cx-clear-btn"
            class="cancel-form tw-mr-3 tw-text-blue-500 tw-font-semibold"
            (click)="clearForm(formDirective)">
            Clear
          </button>
        }
        @if (!locked) {
          <button
            type="button"
            data-cy="cx-close-btn"
            aria-label="Close"
            class="cancel-form tw-flex tw-items-center tw-text-slate-500"
            (click)="closeDrawer()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </div>

    @if (prefilledFields.borrowerId) {
      <div class="tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-text-sm">
        <span class="tw-text-slate-500">
          {{ borrowerIdEditing ? 'Enter the correct borrower ID, then apply.' : 'Borrower ID came from the call.' }}
        </span>
        @if (!borrowerIdEditing) {
          <button
            type="button"
            data-cy="cx-bid-edit-btn"
            class="cancel-form tw-flex tw-items-center tw-text-blue-500 tw-font-semibold"
            (click)="startBorrowerIdEdit()">
            <mat-icon class="tw-mr-1" inline>edit</mat-icon>Edit
          </button>
        } @else {
          <button
            type="button"
            data-cy="cx-bid-apply-btn"
            class="cancel-form tw-text-blue-500 tw-font-semibold"
            [disabled]="borrowerIdValidating"
            (click)="applyBorrowerIdEdit()">
            Apply
          </button>
          <button
            type="button"
            data-cy="cx-bid-cancel-btn"
            class="cancel-form tw-text-slate-500"
            [disabled]="borrowerIdValidating"
            (click)="cancelBorrowerIdEdit()">
            Cancel
          </button>
          @if (borrowerIdValidating) {
            <mat-spinner class="tw-inline-block" diameter="16"></mat-spinner>
          }
        }
        @if (borrowerIdError) {
          <div data-cy="cx-bid-error" class="tw-w-full tw-text-red-600">{{ borrowerIdError }}</div>
        }
      </div>
    }

    <formly-form [model]="model" [fields]="fields" [options]="options" [form]="cxInteractionForm"></formly-form>
   
    <div class="tw-flex save-cx-interaction-button-wrapper">
      <button
        mat-flat-button
        class="save-cx-interaction-button"
        data-cy="cx-interaction-save"
        [disabled]="processing || borrowerIdEditing || borrowerIdValidating"
      >
        @if (!formSaving) {
          <span>Save</span>
        } @else {
          <mat-spinner class="tw-inline-block tw-h-6 tw-w-6" diameter="24"></mat-spinner>
        }
      </button>
    </div>
  </form>
</div>